import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, User } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <>
      <header className="nav-header" style={{ 
        background: 'rgba(255, 252, 245, 0.95)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(15, 23, 42, 0.08)'
      }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <div style={{ 
          fontFamily: "'Playfair Display', Georgia, serif",
          fontWeight: 700, 
          fontSize: '1.35rem', 
          color: '#0F172A',
          letterSpacing: '-0.01em'
        }}>
          Abba Academy
        </div>
      </div>

      {/* Desktop Navigation */}
      <nav style={{ display: 'none' }} className="desktop-nav">
        <a onClick={() => scrollToSection('about')} className="nav-link" style={{ cursor: 'pointer', color: '#334155', fontWeight: 500 }}>About</a>
        <a onClick={() => scrollToSection('services')} className="nav-link" style={{ cursor: 'pointer', color: '#334155', fontWeight: 500 }}>Services</a>
        <a onClick={() => scrollToSection('video-lessons')} className="nav-link" style={{ cursor: 'pointer', color: '#334155', fontWeight: 500 }}>Videos</a>
        <Link to="/store" className="nav-link" style={{ cursor: 'pointer', color: '#C5A059', fontWeight: 600, textDecoration: 'none' }}>Topic Store</Link>
        <a onClick={() => scrollToSection('pricing')} className="nav-link" style={{ cursor: 'pointer', color: '#334155', fontWeight: 500 }}>Pricing</a>
        <a onClick={() => scrollToSection('vacancies')} className="nav-link" style={{ cursor: 'pointer', color: '#334155', fontWeight: 500 }}>Careers</a>
        <a onClick={() => scrollToSection('contact')} className="nav-link" style={{ cursor: 'pointer', color: '#334155', fontWeight: 500 }}>Contact</a>
      </nav>

      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        {/* Student Portal Link */}
        <Link 
          to="/login" 
          className="portal-link"
          style={{ 
            display: 'none',
            alignItems: 'center', 
            gap: '0.5rem', 
            color: '#0F172A', 
            fontWeight: 500,
            fontSize: '0.9rem',
            padding: '0.5rem 1rem',
            borderRadius: '8px',
            border: '1px solid rgba(15, 23, 42, 0.15)',
            textDecoration: 'none',
            transition: 'all 0.2s'
          }}
          data-testid="portal-link"
        >
          <User size={18} />
          <span>Student Portal</span>
        </Link>
        
        <button 
          onClick={() => scrollToSection('contact')} 
          className="btn-premium"
          style={{ display: 'none', padding: '0.75rem 1.5rem', fontSize: '0.9rem' }}
          id="desktop-cta"
        >
          Get Started
        </button>
        
        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '0.5rem',
            display: 'none'
          }}
          className="mobile-menu-btn"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            background: 'white',
            borderRadius: '12px',
            marginTop: '0.5rem',
            padding: '1rem',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
          }}
        >
          <a onClick={() => scrollToSection('about')} className="nav-link" style={{ cursor: 'pointer', width: '100%', textAlign: 'center' }}>About</a>
          <a onClick={() => scrollToSection('services')} className="nav-link" style={{ cursor: 'pointer', width: '100%', textAlign: 'center' }}>Services</a>
          <a onClick={() => scrollToSection('topics')} className="nav-link" style={{ cursor: 'pointer', width: '100%', textAlign: 'center' }}>Topics</a>
          <Link 
            to="/store" 
            className="nav-link" 
            style={{ 
              cursor: 'pointer', 
              width: '100%', 
              textAlign: 'center',
              color: '#C5A059',
              fontWeight: 600,
              textDecoration: 'none'
            }}
            onClick={() => setMobileMenuOpen(false)}
          >
            Topic Store
          </Link>
          <a onClick={() => scrollToSection('video-lessons')} className="nav-link" style={{ cursor: 'pointer', width: '100%', textAlign: 'center' }}>Video Lessons</a>
          <a onClick={() => scrollToSection('pricing')} className="nav-link" style={{ cursor: 'pointer', width: '100%', textAlign: 'center' }}>Pricing</a>
          <a onClick={() => scrollToSection('vacancies')} className="nav-link" style={{ cursor: 'pointer', width: '100%', textAlign: 'center' }}>Tutor Vacancies</a>
          <a onClick={() => scrollToSection('contact')} className="nav-link" style={{ cursor: 'pointer', width: '100%', textAlign: 'center' }}>Contact</a>
          <Link 
            to="/login" 
            className="nav-link" 
            style={{ 
              cursor: 'pointer', 
              width: '100%', 
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              color: '#C5A059',
              fontWeight: 600
            }}
            onClick={() => setMobileMenuOpen(false)}
          >
            <User size={18} />
            Student Portal
          </Link>
          <button onClick={() => scrollToSection('contact')} className="btn-primary" style={{ marginTop: '0.5rem' }}>
            Get Started
          </button>
        </div>
      )}

      <style jsx="true">{`
        @media (min-width: 769px) {
          .desktop-nav {
            display: flex !important;
            gap: 0.5rem;
          }
          #desktop-cta {
            display: inline-flex !important;
          }
          .portal-link {
            display: flex !important;
          }
          .portal-link:hover {
            background: rgba(197, 160, 89, 0.1);
            border-color: #C5A059;
          }
        }
        
        @media (max-width: 768px) {
          .mobile-menu-btn {
            display: block !important;
          }
        }
      `}</style>
    </header>
    </>
  );
};

export default Header;
